<template>
    <div class="card">
        <div class="bg-blue-light p-1">
            <TitleButton 
                :showBtn="false"
                title="Attendance Summary"
            />
        </div>
        <div class="my-2 px-2">
            <DateQuerySetter
                btnTitle="Go"
                @onClickGo="onClickToGo"
                class="tds-vds-query-setter"
            >
              <div  class="col-12 col-sm-6 col-md-4 col-lg-3">
                <label for="colFormLabel" class="col-form-label">Employee</label>
                <AsyncSelect
                    placeholder="Select Employee"
                    v-model="contactProfileId"
                    :api-service="fetchContactProfiles"
                    :additional-query="{roles: 'employee'}"
                    label="name"
                    :reduce="name => name.id"
                />
              </div>
            </DateQuerySetter>
        </div>

        <div class="col-12">
          <div class="d-flex justify-content-end px-2">
            <button
                @click="exportTable"
                class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
            >
              Export
            </button>
          </div>
        </div>

        <div class="col-12 px-2 mt-2 mb-4">
          <div class="table-responsive">
            <table class="table" border="1" width="100%">
              <thead>
              <tr>
                <th class="text-left">Employee</th>
                <th class="text-center">Total Days</th>
                <th class="text-center">Present</th>
                <th class="text-center">Late Present</th>
                <th class="text-center">Absent</th>
                <th class="text-center">Leave</th>
                <th class="text-center">Weekend</th>
                <th class="text-center">Holiday</th>
              </tr>
              </thead>
              <tbody>
                 <tr v-for="employee in tableItems" :key="employee.contact_profile_id">
                     <td class="text-left">
                       <div>{{ employee.name }}</div>
                       <div>{{ employee.designation }}</div>
                     </td>
                     <td class="text-center">{{ employee.grand_total }}</td>
                     <td class="text-center">{{ employee.total.P || 0 }}</td>
                     <td class="text-center">{{ employee.total.LT || 0 }}</td>
                     <td class="text-center">{{ employee.total.A || 0 }}</td>
                     <td class="text-center">{{ employee.total.L || 0 }}</td>
                     <td class="text-center">{{ employee.total.W || 0 }}</td>
                     <td class="text-center">{{ employee.total.H || 0 }}</td>
                 </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="px-2 position-absolute bottom-0 mt-4">
            <Pagination :offset="params.offset" @onPageChange="onPageChange" ref="pagination"/>
        </div>

        <Loader v-if="loading"/>

    </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton';
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { resetPaginationPage } from '@/services/utils/global';
import Loader from '@/components/atom/LoaderComponent'
import Pagination from '@/components/atom/Pagination'
import DateQuerySetter from '@/components/atom/DateQuerySetter.vue';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import { computed } from 'vue';
import handleContact from '@/services/modules/contact'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const contactProfileId = ref('');
const params = ref({
    offset: 30,
});

const token = computed(() => localStorage.getItem('token'));

const {
  fetchAttendanceSummaryReport,
} = handleHrPayroll()
const { fetchContactProfiles } = handleContact()

const onClickToGo = () => {
  getAttendanceSummary();
}

const setPaginationData = (data) => {
    store.commit('setPaginationData', data)
};

const setPagination = (data) => {
    setPaginationData({
        records: data.total,
        perPage: data.per_page,
        currentPage: data.current_page,
    })
}

const onPageChange = async (page) => {
    let routeQuery = Object.assign({}, route.query)
    routeQuery.page = page
    await router.push({path: route.path, query: routeQuery})
    await getAttendanceSummary();
}
const getAttendanceSummary = async () => {
    const query = getQuery();
    loading.value = true
    tableItems.value = []

    await fetchAttendanceSummaryReport(query).then(res => {
        if (!res.status){
            resetPaginationPage(store, route, router)
            return
        }

        tableItems.value = res.data.data;
        setPagination(res.data)
    }).catch(err => {
        console.log(err)
    }).finally(() => {
        loading.value = false
    })
}

const getQuery = () => {
    let query = `?company_id=${route.params.companyId}`;
    if (route.query.page) query += '&page=' + route.query.page;
    if (route.query.start) query += '&start_date=' + route.query.start;
    if (route.query.end) query += '&end_date=' + route.query.end;
    if (contactProfileId.value) query += '&contact_profile_id=' + contactProfileId.value
    query += '&status=approved';
    query += '&offset=' + params.value.offset
    return query;
}

const exportTable = () => {
  let query = getQuery();
  let url = `${process.env.VUE_APP_BASE_URL}/api/hr-payroll/attendance-summary${query}&_token=${token.value}&is_export=1&is_all=true`;
  let a = document.createElement("a");
  a.setAttribute("href", url);
  a.click();
};

</script>